// extracted by mini-css-extract-plugin
export var author = "recipe-ingredient-list-module--author--ZzjmS";
export var header = "recipe-ingredient-list-module--header--Yf3hq";